<template>
    <svg version="1.1"  v-bind:class="{turnOn: isTurnOn}"  id="Alarm" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 250 250" style="enable-background:new 0 0 250 250;" xml:space="preserve">
        <g>
            <g id="Switch">
                <path class="st0" d="M126.7,50.9h-0.1c-3.7,0-6.7-3-6.7-6.7V20c0-3.7,3-6.7,6.7-6.7h0.1c3.7,0,6.7,3,6.7,6.7v24.2C133.3,47.9,130.3,50.9,126.7,50.9z"/>
                <path class="st1" d="M111.2,27.7v-0.1c0-3.9,3.2-7,7-7h16.4c3.9,0,7,3.2,7,7v0.1c0,3.9-3.2,7-7,7h-16.4C114.4,34.8,111.2,31.6,111.2,27.7z"/>
            </g>
            <g id="Legs">
		        <path class="st0" d="M184.8,236.3l-2.4,1.4c-5.1,3.1-12.3,0.2-16-6.5l-30.6-56.1c-3.7-6.7-2.4-14.7,2.7-17.8l2.4-1.4c5.1-3.1,12.3-0.2,16,6.5l30.6,56.1C191.2,225.1,190,233.1,184.8,236.3z"/>
                <path class="st0" d="M72.2,239.1l2.6,1.5c5.1,3.1,12.3,0.2,16-6.5l30.6-56.1c3.7-6.7,2.4-14.7-2.7-17.8l-2.6-1.5c-5.1-3.1-12.3-0.2-16,6.5l-30.6,56.1C65.9,227.9,67.1,235.9,72.2,239.1z"/>
	        </g>
            <g id="Body">
                <ellipse class="st1" cx="125.3" cy="132.5" rx="85.3" ry="89.9"/>
            </g>
            <g id="Contour">
                <ellipse class="st2" cx="125.8" cy="133" rx="69.6" ry="74.6"/>
            </g>
            <g id="BodyClockFace">
                <ellipse class="st3" cx="125.2" cy="132.7" rx="65.8" ry="69.4"/>
            </g>
            <g id="Bell">
		        <path class="st0" d="M54.8,33.2C40,44.9,36.4,66.4,46.5,81.8c8.9-6.2,18.1-13,27.6-20.5c9.8-7.7,18.9-15.4,27.2-22.9c-1.6-2.1-8.6-10.6-21-12.3C66.6,24.1,56.5,31.8,54.8,33.2z"/>
                <path class="st0" d="M195.4,33.1c14.8,12.1,18.2,33.8,8,49c-8.9-6.4-18.2-13.5-27.7-21.3c-9.8-8-18.9-16-27.3-23.7c1.6-2,8.7-10.4,21.3-11.8C183.5,23.7,193.6,31.7,195.4,33.1z"/>
	        </g>
            <g id="ClockFace">
		        <path class="st0" d="M153.1,89.5c-1.3-0.9-1.7-2.8-0.8-4.1c2.5-3.9,4.9-7.9,7.4-11.8c1.5,1.1,3,2.1,4.5,3.2c-2.4,4-4.8,7.9-7.1,11.9C156.2,90,154.4,90.4,153.1,89.5z"/>
                <path class="st0" d="M169.6,109.6c-0.7-1.5-0.1-3.3,1.3-4c4-2,8.1-4.1,12.1-6.1c0.8,1.7,1.6,3.4,2.3,5.1c-4,2.1-7.9,4.3-11.9,6.4C172,111.7,170.3,111.1,169.6,109.6z"/>
                <path class="st0" d="M175,135.9c0.1-1.6,1.4-2.9,2.9-2.9c4.4,0.2,8.8,0.5,13.1,0.7c-0.1,1.9-0.2,3.8-0.3,5.7c-4.4-0.1-8.7-0.3-13.1-0.4C176.1,138.9,174.9,137.5,175,135.9z"/>
                <path class="st0" d="M167.3,160.7c0.8-1.4,2.5-1.9,3.9-1.1c3.8,2.4,7.6,4.8,11.4,7.2c-0.9,1.6-1.9,3.2-2.8,4.9c-3.8-2.3-7.6-4.6-11.4-6.9C166.9,164,166.5,162.2,167.3,160.7z"/>
                <path class="st0" d="M151.5,177.4c1.3-0.9,3.1-0.5,3.9,0.8c2.4,3.9,4.8,7.8,7.2,11.7c-1.5,1-3,2-4.6,3.1c-2.5-3.8-4.9-7.7-7.4-11.5C149.8,180.2,150.2,178.3,151.5,177.4z"/>
                <path class="st0" d="M128.3,185.3c1.5-0.1,2.9,1.2,3,2.8c0.2,4.6,0.4,9.2,0.6,13.8c-1.8,0.1-3.5,0.1-5.3,0.2c-0.3-4.6-0.6-9.1-0.9-13.7C125.6,186.8,126.8,185.4,128.3,185.3z"/>
                <path class="st0" d="M103.6,180.4c1.4,0.7,2,2.5,1.3,4c-2,4.1-3.9,8.2-5.9,12.3c-1.6-0.9-3.2-1.8-4.8-2.6c1.9-4.1,3.7-8.2,5.6-12.3C100.5,180.2,102.2,179.7,103.6,180.4z"/>
                <path class="st0" d="M85.2,164.4c0.9,1.3,0.7,3.2-0.6,4.2c-3.6,2.7-7.1,5.4-10.7,8c-1-1.6-2.1-3.1-3.1-4.7c3.5-2.7,7-5.5,10.5-8.2C82.5,162.7,84.3,163,85.2,164.4z"/>
                <path class="st0" d="M75.5,137.7c0.1,1.6-1,3.1-2.6,3.2c-4.4,0.3-8.8,0.7-13.2,1c-0.1-1.9-0.2-3.8-0.4-5.7c4.4-0.4,8.7-0.9,13.1-1.3C74,134.8,75.4,136.1,75.5,137.7z"/>
                <path class="st0" d="M80.3,109.5c-0.7,1.5-2.3,2.2-3.7,1.5c-4-2-8-4-11.9-6c0.8-1.7,1.6-3.4,2.4-5.1c4,1.9,8,3.8,12,5.7C80.4,106.2,81,108,80.3,109.5z"/>
                <path class="st0" d="M98.6,88.3c-1.3,0.9-3.1,0.5-3.9-0.8c-2.4-3.9-4.7-7.8-7.1-11.8c1.5-1,3.1-2,4.6-3c2.4,3.8,4.9,7.7,7.3,11.5C100.3,85.6,99.9,87.4,98.6,88.3z"/>
                <path class="st0" d="M125.2,80c-1.6,0-2.8-1.3-2.9-2.9c0-4.6,0.1-9.3,0.1-13.9c1.8,0,3.6,0.1,5.4,0.1c0.1,4.6,0.1,9.2,0.2,13.8C128.1,78.7,126.8,80,125.2,80z"/>
            </g>
            <g id="Arrows">
		        <path id="MainArrow" class="st4" d="M92.4,136.1L92.4,136.1c0-2.7,2.2-4.9,4.8-4.9h22.2c2.6,0,4.8,2.2,4.8,4.8v0.1c0,2.6-2.2,4.8-4.8,4.8H97.2C94.5,141,92.4,138.8,92.4,136.1z"/>
                <path id="Arrow2_" class="st5" d="M125.5,137.1L125.5,137.1c-2.6,0-4.7-2.1-4.7-4.6V93.4c0-2.5,2.1-4.6,4.6-4.6h0.1c2.5,0,4.6,2.1,4.6,4.6v39.1C130.1,135,128,137.1,125.5,137.1z"/>
                <path id="Arrow1" class="st4" d="M127.3,136.4L127.3,136.4c-2.1,1.5-5,0.9-6.5-1.3l-20.1-31.8c-1.4-2.3-0.9-5.4,1.2-6.9l0,0c2.1-1.5,5-0.9,6.5,1.3l20.1,31.8C130,131.7,129.4,134.9,127.3,136.4z"/>
                <ellipse id="Middle" class="st6" cx="125.1" cy="135.6" rx="8.8" ry="9.3"/>
	        </g>
            <g id="Lines" class="st7">
                <g class="st8">
                    <path class="st9" d="M188.9,14.8c2.2,0.2,14.2,1.7,24.6,11.9c5.4,5.4,8.1,10.8,9.3,13.8c-1.5-2.1-3.8-5.1-7-8.5c-3.6-3.8-8.5-8.9-15.9-12.9C197.4,17.8,193.6,16,188.9,14.8z"/>
                    <path class="st9" d="M201.7,12.2c1.6,0,9.9,0.4,16.6,7.3c3.5,3.6,5.1,7.5,5.8,9.6c-1-1.5-2.4-3.6-4.5-5.9c-2.3-2.6-5.5-6.1-10.5-8.6C207.6,13.9,205,12.8,201.7,12.2z"/>
                </g>
                <g class="st8">
			        <path class="st9" d="M33.4,38c0.9-2.2,6-13.7,18.4-20.9c6.5-3.8,12.3-4.7,15.4-5c-2.4,0.9-5.8,2.2-9.9,4.4c-4.6,2.4-10.7,5.7-16.6,11.8C38.7,30.3,36,33.5,33.4,38z"/>
                    <path class="st9" d="M35.1,24.3c0.5-1.5,3.5-9.8,11.8-14.3c4.4-2.4,8.4-2.8,10.5-2.8c-1.6,0.5-4,1.3-6.7,2.7c-3.1,1.5-7.2,3.6-11,7.8C38.5,19,36.7,21.2,35.1,24.3z"/>
		        </g>
                <g class="st8">
			        <path class="st9" d="M215.6,119.6c1.1,2.3,7.1,15,5.4,31.9c-0.9,8.9-3.5,15.2-5.1,18.4c0.7-2.9,1.7-7.2,2.3-12.6c0.8-6.1,1.8-14.2,0.5-24.1C218.3,129.9,217.5,125.1,215.6,119.6z"/>
                    <path class="st9" d="M225.1,130.4c0.9,1.5,5.5,9.9,4.2,21.1c-0.7,5.9-2.7,10-3.9,12.2c0.6-1.9,1.3-4.8,1.8-8.3c0.6-4,1.4-9.4,0.4-16C227.3,137.2,226.6,134,225.1,130.4z"/>
		        </g>
                <g class="st8">
			        <path class="st9" d="M41.2,171.7c-1.5-2.1-9.2-13.7-9.9-30.6c-0.4-8.9,1.3-15.6,2.4-19c-0.3,3-0.6,7.4-0.5,12.8c0.1,6.1,0.3,14.4,2.9,23.9C37,162,38.6,166.6,41.2,171.7z"/>
                    <path class="st9" d="M30.2,162.6c-1.1-1.4-6.9-9-7.2-20.2c-0.2-5.9,1.3-10.4,2.2-12.6c-0.3,2-0.6,4.9-0.6,8.5c0,4.1,0,9.5,1.9,15.8C27.1,156.2,28.2,159.3,30.2,162.6z"/>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "alarm",
        props:{
            isTurnOn: {
                type: Boolean,
                default: false,
            }
        }
    }
</script>

<style scoped lang="scss">
    /*Включено*/
    .turnOn{
        /*Линии, стрелка при включенном состоянии*/
        #Lines,#Arrow2{display: block !important;}
        /*Стрелка при выключенном состоянии*/
        #Arrow1{display: none !important;}
    }
    .st0{fill:#495154;}
    .st1{fill:#4D8D93;}
    .st2{fill:#626A6D;}
    .st3{fill:#EADC96;}
    .st4{fill:#CC3B0E;}
    .st5{display:none;fill:#CC3B0E;}
    .st6{fill:#47291E;}
    .st7{display:none;}
    .st8{display:inline;}
    .st9{fill:#838484;}
    .st10{fill:none;stroke:#000000;stroke-miterlimit:10;}

</style>